import { goToToday } from '../actions/goToToday';
import { refreshDayPicker } from '../actions/refreshDayPicker';
import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import { updateDateRange, updateSelectedDate } from 'owa-calendar-surface';
import { getNumDaysInDayRange } from 'owa-calendar-surface-options-utils';
import { getSurfaceStore } from 'owa-calendar-surface-surface-store';
import { loadItemsOnDateRangeChange } from 'owa-calendar-surface-view-store';
import { today } from 'owa-datetime';
import { DisplayDate } from 'owa-datetime';
import { areDateRangesEqual, createDateRangeFromType, DateRange } from 'owa-datetime-utils';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { orchestrator } from 'satcheljs';

// TODO: VSO #88707 Separate module vs surface concerns in Calendar module
// Action-handling needs to be split up so that mini-month is always updated + surface navigates when open

export const goToTodayOrchestrator = orchestrator(goToToday, () => {
    const currentDay = today();

    const surfaceStore = getSurfaceStore();

    const newDateRange = getTodayRange(
        surfaceStore.dateRangeType,
        currentDay,
        surfaceStore.userOptions.workDays,
        getNumDaysInDayRange()
    );

    const sameDateRange = areDateRangesEqual(newDateRange, surfaceStore.dateRange);
    updateDateRange(newDateRange, surfaceStore);
    updateSelectedDate(currentDay, surfaceStore);

    refreshDayPicker();

    if (!sameDateRange) {
        loadItemsOnDateRangeChange(newDateRange, surfaceStore.dateRangeType);
    }
});

function getTodayRange(
    dateRangeType: DateRangeType,
    currentDay: DisplayDate,
    workDays: number[],
    numOfDaysInDayRange?: number
): DateRange {
    const firstDayOfWeek = getUserConfiguration().UserOptions.WeekStartDay;
    return createDateRangeFromType(
        dateRangeType,
        currentDay,
        firstDayOfWeek,
        workDays,
        numOfDaysInDayRange
    );
}
